import { render } from "./edit-client-file.vue?vue&type=template&id=ef9b783a"
import script from "./edit-client-file.vue?vue&type=script&lang=js"
export * from "./edit-client-file.vue?vue&type=script&lang=js"

import "./edit-client-file.vue?vue&type=style&index=0&id=ef9b783a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__